import { httpClient } from "@/services";
import { shortPaymentsHeader } from "@/constants/defaultHeader";

export default {
	state: {
		shortPaymentsList: [],
		shortPaymentsFilterList: {},
		shortPaymentsActions: [],
		shortPaymentsLoad: [],

		shortPaymentsExportLink: null,
		shortPaymentsSettingsDefault: null,
		shortPaymentsSettings: null,
		shortPaymentsHeaders: [],
	},
	mutations: {
		updateShortPaymentsSettingsAll(state, payload) {
			state.shortPaymentsSettings = state.shortPaymentsSettings.map(item => {
				item.settings = payload;
				return item;
			});
		},
		updateShortPaymentsSettingsReset(state) {
			state.shortPaymentsSettings = state.shortPaymentsSettingsDefault.map(item => ({ ...item }));
		},
		updateShortPaymentsExportLink(state, payload) {
			state.shortPaymentsExportLink = payload;
		},
		updateShortPaymentsList(state, payload) {
			const { rows, filters, settings } = payload;

			state.shortPaymentsList = rows;
			state.shortPaymentsFilterList = filters;

			if (settings && settings.length > 0) {
				state.shortPaymentsSettingsDefault = settings;
				state.shortPaymentsSettings = settings.map(item => ({ ...item }));
				state.shortPaymentsHeaders = [];
				settings.map(item => {
					if (item.settings) {
						state.shortPaymentsHeaders.push(item);
					}
				});
			} else {
				state.shortPaymentsSettingsDefault = shortPaymentsHeader;
				state.shortPaymentsSettings = shortPaymentsHeader.map(item => ({ ...item }));
				state.shortPaymentsHeaders = [];
				shortPaymentsHeader.map(item => {
					if (item.settings) {
						state.shortPaymentsHeaders.push(item);
					}
				});
			}
		},
		deleteShortPaymentsAction(state, payload) {
			state.shortPaymentsActions = state.shortPaymentsActions.filter(action => action.id !== payload);
		},
		updateShortPaymentsActions(state, { action, load }) {
			state.shortPaymentsActions = action;
			state.shortPaymentsLoad = load;
		},
	},
	actions: {
		async onShortPaymentsSettingsSave({ dispatch, state }) {
			dispatch("actionPreloader", true);
			try {
				await httpClient.post('/short/payments/settings', { settings: state.shortPaymentsSettings });
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		onShortPaymentsSettingsAll({ commit }, payload) {
			commit('updateShortPaymentsSettingsAll', payload);
		},
		onShortPaymentsSettingsReset({ commit }) {
			commit('updateShortPaymentsSettingsReset');
		},
		async getShortPaymentsExport({ commit, dispatch }, value) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post("/short/payments/export", value);

				if (data) {
					commit('updateShortPaymentsExportLink', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async onShortPaymentsList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/short/payments');
				if (data && !data.status) {
					commit('updateShortPaymentsList', data);
				} else {
					console.error('Something went wrong!!!');
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onShortPaymentsFilter({ commit }, values) {
			try {
				const { data } = await httpClient.post('/short/payments', values);

				if (data && !data.status) {
					commit('updateShortPaymentsList', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onShortPaymentsActions({ commit }, { id }) {
			return await httpClient.get(`/short/payments/${ id }/edit`).then(result => {
				if (result.status) {
					commit('updateShortPaymentsActions', result.data);
				}
			});
		},
		async addShortPaymentsActions({ commit }, values) {
			const { id, ...body } = values;
			return await httpClient.put(`/short/payments/${ id }`, body).then(result => {
				if (result.status) {
					commit('updateShortPaymentsActions', result.data);
				}
			});
		},
		async editShortPaymentsActions({ commit }, values) {
			const { id, action_text } = values;
			return await httpClient.post(`/schedules/action/${ id }`, { action_text }).then(result => {
				if (result.status) {
					commit('updateShortPaymentsActions', result.data);
				}
			});
		},
		async onDeleteShortPaymentsActions({ commit }, { id }) {
			await httpClient.delete(`/short/payments/${ id }`).then(result => {
				if (result.status) {
					commit('deleteShortPaymentsAction', id);
				}
			});
		},
		async onSaveShortPaymentLoad(context, { id, amount_factoring, status }) {
			return await httpClient.post(`/schedules/load/${ id }`, { amount_factoring, status });
		}
	},
	getters: {
		shortPaymentsList: s => s.shortPaymentsList,
		shortPaymentsFilterList: s => s.shortPaymentsFilterList,
		shortPaymentsActions: s => s.shortPaymentsActions,

		shortPaymentsExportLink: s => s.shortPaymentsExportLink,
		shortPaymentsSettingsDefault: s => s.shortPaymentsSettingsDefault,
		shortPaymentsSettings: s => s.shortPaymentsSettings,
		shortPaymentsHeaders: s => s.shortPaymentsHeaders,
	}
};
